<template>
  <!-- 2カラムページの場合は'is-2column'クラスを付与 -->
  <!-- ヘッダーを隠すの場合は'is-hidden-header'クラスを付与 -->
  <div id="body" class="is-2column" 
    :class="{'is-hidden-header' : targetScrollFlg}"
  >
  <BackgroundImage />
  <DocumentLink />

  <PCPrint />
    <!-- menu:start -->
    <PCMenu
      class="visible"
      v-if="visibleMenu"
      @searchByKeyword="action.preSearch"
      @closeMenu="visibleMenu = false"
    />
    <!-- menu:end -->
    
    <!-- ノートの削除アップデート通知 -->
    <transition name="popup">
      <PCNoteDeleteConfirm
        v-if="state.visible.deleteConfirm"
        @closeNoteDeleteConfirm="state.visible.deleteConfirm = false"
      />
    </transition>

    <!-- ノートの複製アップデート通知 -->
    <transition name="popup">
      <PCNoteCopyConfirm
        v-if="state.visible.copyConfirm"
        @closeNoteCopyConfirm="state.visible.copyConfirm = false"
      />
    </transition>

    <!-- ノートの並び順 -->
    <transition name="popup">
      <PCNoteSearchOrderSetting
        v-if="state.visible.searchOrderSetting"
        @close="state.visible.searchOrderSetting = false"
      />
    </transition>

    <!-- 閲覧/編集権限付与アカウント一覧ウィンドウ -->
    <transition name="popup">
      <PCNoteUserPermissionsList
        v-if="state.visible.visibleNoteUserPermissionsList"
        @close="state.visible.visibleNoteUserPermissionsList = false"
      />
    </transition>

    <!-- 閲覧/編集権限付与設定ウィンドウ -->
    <transition name="popup">
      <PCNoteUserPermissionsEdit
        v-if="state.visible.visibleNoteUserPermissionsEdit"
        @close="share.hideNoteUserPermissionsEdit"
      />
    </transition>

    <div id="wrapper">
      <!-- header:start -->
      <PCSearchUI 
        :screenType="'note'"
        :isAlertShown="false"
        :isSearchExecutedAtSameScreen="true"
        :historyBackAction="historyBackAction"
        @search="action.search"
      />
      <!-- header:end -->

      <!-- menu-bar:start -->
      <!-- open -->
      <div class="menu-bar" role="button" 
        :class="{'is-open' : !targetScrollFlg}"
        @click="visibleMenu = !visibleMenu"
      >
        <IconMenu class="icn" 
          v-if="!targetScrollFlg"
        />
        <FontawesomeIcon :icon="['far','chevron-up']" size="lg" class="icn"
          v-if="targetScrollFlg"
        />
      </div>
      <!-- close -->
      <!-- menu-bar:end -->

      <!-- content:start -->
      <div id="content" :class="{'content-no-position' : state.visibleNotePartPreventForgettingToSave && visibleMenu}">
        <div class="navigation pb72" id="navi" style="max-height:calc(100vh - 16px);">
          <div v-if="narrow.tags.length > 0 || narrow.filterTagsExcludeTag.length > 0" class="navigation-title">
            <span class="navigation-title-main">タグ</span>
            <router-link to="/pc/tag-list" class="navigation-title-sub">タグの管理</router-link>
          </div>
          
          <div v-if="narrow.tags.length > 0" class="navigation-tags">
            <div v-for="(tag, index) in narrow.tags" :key="'tag_' + index" class="tag bottom">
              <div @click="narrow.setTags(tag)" role="button" class="tag-wrap">
                <span class="tag-text">{{tag.name}}</span>
              </div>
            </div>
          </div>
          <div v-if="narrow.filterTagsExcludeTag.length > 0" class="navigation-tags">
            <div v-for="(tag, index) in narrow.filterTagsExcludeTag" :key="'filterTag_' + index" class="tag">
              <div @click="narrow.resetTags(tag)" role="button" class="tag-wrap">
                <span class="tag-text">{{tag.name}}</span>
                <span class="tag-close"><FontawesomeIcon icon="times" size="xs" class="icn" /></span>
              </div>
            </div>
          </div>
          <div v-if="narrow.userLists.length > 0" class="navigation-title">
            <span class="navigation-title-main">絞り込み</span>
          </div>
          <div v-if="narrow.userLists.length > 0" class="navigation-list">
            <nav class="list01 bg-02">
              <CheckBoxTree
                :categories="narrow.userLists"
                :checked="narrow.userChecked" 
                @checkSet="narrow.checkUpdate"
                />
            </nav>
          </div>
        </div>
        <main class="" id="main">
          <div class="box02 white">
            <div v-if="state.isSearch" class="box02-hdg">
              <h1 class="box02-hdg-title hdg03">検索結果</h1>
              <span class="box02-hdg-title-sup">{{state.noteCount}}件</span>
              <span @click="action.reset" class="box02-hdg-title-sup-link" role="button">検索をクリア</span>
            </div>
            <div class="box02-body" 
              :class="{'is-note-full': state.isFullSize}"
              >
              <div class="box02-body-title">
                <div class="box02-body-title-navi">
                  <span role="button" class="box02-body-title-navi-link"
                    @click="state.visible.searchOrderSetting = true"
                  >
                    並び順 - {{state.orderDisplay}}
                  </span>
                </div>
                <div class="box02-body-title-button">
                  <div @click="action.newNote" class="button ga-note-mode-edit">
                    <span role="button" class="btn ga-note-mode-edit">ノートの新規作成</span>
                  </div>
                </div>
                <ul v-if="data.noteLists.length > 0 || !note.complete" class="box02-body-title-list"
                  :class="[state.isSearch && 'is-search']"
                 @scroll="action.scroll"
                >
                  <li v-for="noteList in data.noteLists" :key="'noteList_' + noteList.id"
                    :class="[state.currentNote(noteList.id) && 'is-active']"
                    class="box02-body-title-list-item"
                    @click="action.setCurrentId(noteList.id)"
                    role="button"
                    >
                    <span class="box02-body-title-list-item-title">
                      <template v-for="(string, stIndex) in noteList.title.split(regExp)">
                        <span v-if="keywordSplit.includes(string.toLowerCase())" class="yellow" :key="'title_' + stIndex">{{string}}</span>
                        <template v-else>{{string}}</template>
                      </template>
                    </span>
                    <div class="box02-body-title-list-item-icn">
                      <span v-if="noteList.user_file_id > 0" class="box02-body-title-list-item-prof" :style="[noteList.image && {backgroundImage : 'url(' + noteList.image + ')'}]"></span>
                      <span v-else class="box02-body-title-list-item-prof no-image">{{noteList.create_user_name.slice(0, 1)}}</span>
                      <span class="box02-body-title-list-item-auth" v-if="noteList.share_classification === 21">閲覧</span>
                      <span class="box02-body-title-list-item-auth edit" v-else-if="noteList.share_classification === 22">編集</span>
                    </div>
                  </li>
                  <li v-if="!note.complete" ref="LoadingBlock">
                    <FontawesomeIcon :icon="['fal','spinner-third']" size="2x" class="mt20 mb20 icn fa-spin" />
                  </li>
                </ul>
              </div>
              <div v-if="state.isEditMode || (data.noteLists.length > 0 || !note.complete)" class="box02-body-detail" :style="{'border: 0px': state.isFullSize}">
                <div class="box02-body-detail-menu">
                  <div @click="action.onViewModeTabClicked"
                    :role="!state.isDetailMode ? 'button' : ''"
                    :class="{'is-active': state.isDetailMode}" 
                    class="box02-body-detail-menu-item ga-note-mode-view">
                    <span class="box02-body-detail-menu-item-label ga-note-mode-view">
                      閲覧モード
                    </span>
                  </div>
                  <div v-if="state.isEditable || state.visible.mode === 'create'" 
                    @click="action.onEditModeTabClicked" 
                    :role="!state.isEditMode ? 'button' : ''"
                    :class="{'is-active': state.isEditMode}" 
                    class="box02-body-detail-menu-item ga-note-mode-edit">
                    <span class="box02-body-detail-menu-item-label ga-note-mode-edit">
                      編集モード
                    </span>
                  </div>
                  <div v-show="state.isDetailMode" class="navi">
                    <div class="navi-item">
                      <span class="navi-item-label" role="button"
                        @click="state.visible.copyConfirm = true"
                      >ノートの複製</span>
                    </div>
                    <div v-if="state.isOwn" class="navi-item">
                      <span class="navi-item-label" role="button"
                        @click="state.visible.deleteConfirm = true"
                      >ノートの削除</span>
                    </div>
                    <div class="navi-item">
                      <span role="button" class="navi-item-icon"
                        v-if="!state.isFullSizeNote"
                        @click="state.isFullSizeNote = true"
                        >
                        <span class="tip">拡大</span>
                        <FontawesomeIcon :icon="['far','expand-alt']" />
                      </span>
                      <span role="button" class="navi-item-icon"
                        v-if="state.isFullSizeNote"
                        @click="state.isFullSizeNote = false"
                        >
                        <span class="tip">縮小</span>
                        <FontawesomeIcon :icon="['far','compress-alt']" />
                      </span>
                      <span role="button" class="navi-item-icon ga-print"
                        @click="printTarget('note-content')"
                        >
                        <span class="tip">印刷</span>
                        <FontawesomeIcon :icon="['far','print']" class="ga-print" />
                      </span>
                    </div>
                  </div>
                </div>
                <PCNoteDetail
                  v-show="state.isDetailMode"
                  :search="state.search"
                  @openNoteUserPermissionsList="share.openNoteUserPermissionsList"
                  @scroll="handleScroll"
                  />
                <PCNoteEdit
                  v-show="state.isEditMode"
                  @scroll="handleScroll"
                  @finishEditMode="action.changeMode('detail'), state.isFullSizeNote = false"
                  @closeMenu="visibleMenu = false"
                  @loadPage="action.loadPage"
                  @search="action.searchStep2"
                  @loadAfterUserChecked="narrow.loadAfterUserChecked"
                  @loadAfterTagChanged="narrow.loadAfterTagChanged"
                />
              </div>
              <div v-else class="box02-body-detail">
                <div v-show="!state.isEditMode" class="box02-body-detail-content">
                  <div class="box02-body-detail-content-body no-content"
                    ref="areaScrollable"
                    :style="{'height' : state.scrollableHeight + 'px'}"
                    @scroll="handleScroll"
                  >
                    <p class="txt">ノートがありません。<br>ノートは「ノートの新規作成」から作成いただけます。</p>
                  </div>
                </div>
                <PCNoteEdit
                  v-show="state.isEditMode"
                  @scroll="handleScroll"
                  @finishEditMode="state.visible.mode = 'detail', state.isFullSizeNote = false"
                  @closeMenu="visibleMenu = false"
                  @search="action.searchStep2"
                  @loadAfterUserChecked="narrow.loadAfterUserChecked"
                  @loadAfterTagChanged="narrow.loadAfterTagChanged"
                />
              </div>
            </div>
          </div>
        </main>
      </div>
      <!-- content:end -->

      <span id="btnTop" @click="scrollAreaTop('#note-content')">TOP</span>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'

import PCPrint from '@/components/pc/partial/PCPrint.vue'
import PCNoteDetail from '@/components/pc/partial/note/PCNoteDetail.vue'
import PCNoteEdit from '@/components/pc/partial/note/PCNoteEdit.vue'

import PCSearchUI from '@/components/pc/partial/PCSearchUI'
import PCMenu from '@/components/pc/popup/PCMenu.vue'
import PCNoteDeleteConfirm from '@/components/pc/popup/PCNoteDeleteConfirm.vue'
import PCNoteCopyConfirm from '@/components/pc/popup/PCNoteCopyConfirm.vue'
import PCNoteSearchOrderSetting from '@/components/pc/popup/PCNoteSearchOrderSetting.vue'
import CheckBoxTree from '@/components/pc/partial/CheckBoxTree.vue'
import PCNoteUserPermissionsList from '@/components/pc/popup/PCNoteUserPermissionsList.vue'
import PCNoteUserPermissionsEdit from '@/components/pc/popup/PCNoteUserPermissionsEdit.vue'

import store from '@/store'
import { noteChanged, isFromAdminSystem } from '@/util/common'
import { NoteList } from '@/logic/note/NoteList'

export default defineComponent({
  beforeRouteEnter (to, from, next) {
    next()
  },
  beforeRouteLeave (to, from, next) {
    // ノートが編集中か確認し、編集中の場合は遷移させない
    if (noteChanged()) {
      store.dispatch('note/setLinkTo', { type: 'route', to: to.name})
      store.dispatch('note/showDialogToPreventForgettingToSave')
    } else {
      next()
    }
  },
  components: {
    PCPrint,
    PCNoteDetail,
    PCNoteEdit,
    PCSearchUI,
    PCMenu,
    PCNoteDeleteConfirm,
    PCNoteCopyConfirm,
    PCNoteSearchOrderSetting,
    CheckBoxTree,
    PCNoteUserPermissionsList,
    PCNoteUserPermissionsEdit
  },  
  setup (props, context) {
    
    return {
      isFromAdminSystem,
      ...NoteList(props, context)
    }
  }
})
</script>

<style lang="scss" scoped>
#content {
  &.content-no-position {
    position: initial;
  }
}
.box02 {
  border-top-right-radius: 8px;
}
.no-content {
  padding: 40px;
  overflow: auto;
}
.box02-body {
  display: flex;
  height: auto!important;
  overflow: auto!important;
  &-title,
  &-title {
    width: 30%;
    position: relative;
    &-navi {
      text-align: right;
      color: $color-link;
      font-size: 1.4rem;
      padding: 20px 40px;
      &-link {
        display: inline-block;
        @include hoverOpacity;
      }
    }
    &-button {
      border-top: 1px solid $color-line;
      padding: 20px 32px;
    }
    &-list {
      list-style: none;
      padding-bottom: 72px;
      overflow-y: auto;
      max-height: calc(100vh - 166px);
      &.is-search {
        max-height: calc(100vh - 255px);
      }
      &-item {
        padding: 4px 40px;
        min-height: 44px;
        display: flex;
        align-items: center;
        @include hoverOpacity;
        &.is-active {
          background-color: $color-selected;
        }
        &-icn {
          position: relative;
          padding-right: 20px;
        }
        &-title {
          width: calc(100% - 46px);
          color: $color-link;
        }
        &-prof {
          @include profileImage();
          // width: 52px;
          // height: 52px;
          // border-radius: 50%;
        }
        &-auth {
          padding: 3px 4px;
          position: absolute;
          bottom: 0;
          right: 0;
          font-size: 10px;
          border: 1px solid #EEEEEE;
          color: #646464;
          line-height: 1;
          background-color: #EEEEEE;
          border-radius: 2px;
          z-index: 10;
          &.edit {
            background-color: #80889B;
            color: #FFFFFF;
          }
        }
      }
    }
  }
  &-detail {
    transition: all .2s ease;
    width: 70%;
    border-left: 1px solid $color-line;
    &-menu {
      margin: 0 20px;
      position: relative;
      &-item {
        display: inline-block;
        padding: 20px 0;
        color: $color-link;
        font-size: 1.6rem;
        font-weight: bold;
        position: relative;
        @include hoverOpacity;
        &.is-active:before {
          content: '';
          position: absolute;
          left: 0;
          bottom: 0;
          display: block;
          height: 2px;
          width: 100%;
          background-color: $color-yellow;
        }
        &-label {
          display: block;
          padding: 4px 20px;
          color: $color-link;
        }
        & + .box02-body-detail-menu-item .box02-body-detail-menu-item-label {
          border-left: 1px solid $color-line;
        }
      }
      .navi {
        position: absolute;
        right: 0px;
        top: 50%;
        transform: translate3d(0,-50%,0);
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        color: $color-link;
        font-size: 1.4rem;
        &-item {
          display: inline-block;
          padding: 4px 20px;
          &:nth-child(n+2) {
            border-left: 1px solid $color-line;
          }
          &-label,
          &-icon {
            color: $color-link;
            white-space: nowrap;
            margin-right: 10px;
            background-color: #fff;
            display: inline;
            padding: 5px;
            border-radius: 4px;
            border: 0;
            position: relative;
            .tip {
              position: absolute;
              top: -20px;
              margin-left: 4px;
              transform: translate3d(-50%,0,0);
              font-size: 1.4rem;
              font-weight: normal;
              white-space: nowrap;
              opacity: 0;
              transition: opacity .2s;
            }
            &:hover {
              -webkit-box-shadow: 0 5px 20px rgb(0 0 0 / 16%);
              box-shadow: 0 5px 20px rgb(0 0 0 / 16%);
              .tip {
                opacity: 1;
              }
            }
          }
          &-icon + .navi-item-icon {
            margin-left: 20px;
          }
          &:last-child {
            padding-right: 0;
          }
        }
      }
    }
  }
  &.is-note-full {
    .box02-body-title {
      width: 0;
      visibility: hidden;
      opacity: 0;
    }
    .box02-body-detail {
      width: 100%;
      border: 0px;
    }
  }
}
.navigation {
  overflow-y: auto;
  &-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    &-sub {
      color: #fff;
      font-size: 1.4rem;
      @include hoverOpacity;
    }
  }
  &-tags {
    background-color: rgba(0,0,0,.1);
    padding: 8px 20px 20px;
    overflow-y: auto;
    .tag {
      &-wrap {
        background-color: transparent;
        &:hover {
          border: 1px solid $color-line;
        }
      }
      &-text {
        color: #fff;
      }
    }
    & + .navigation-title {
      border-top: 1px solid rgba(255,255,255,.1);
    }
    & + .navigation-tags {
      border-top: 1px solid rgba(255,255,255,.1);
      padding-top: 12px;
    }
  }
  &-footer {
    border-bottom: 1px solid rgba(255,255,255,.1);
    .button {
      border: 1px solid $color-line;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      padding: 12px;
      margin: 20px;
      @include hoverOpacity;
    }
  }
}

</style>
